import './Footer.css';

function Footer() {
  return null;
}

export default Footer;